import { render, staticRenderFns } from "./OauthClientRedirectUrisTable.vue?vue&type=template&id=e3c2e806"
import script from "./OauthClientRedirectUrisTable.vue?vue&type=script&lang=js"
export * from "./OauthClientRedirectUrisTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports